import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { use, useEffect, useState } from 'react';
import Loader from '../components/Loader'
import countries from '../countries.json'


const CheckoutForm = (product) => {

  const [loader, setLoader] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [message, setMessage] = useState('');

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");

  const [accountNumber, setAccountNumber] = useState('')
  const [ShowAccountNumber, setShowAccountNumber] = useState(false)
  const [TransactionID, setTransactionID] = useState(0);

  const [credit_party_identifier_fields, setCredit_party_identifier_fields] = useState('Mobile')

  const [countryCode, setCountryCode] = useState('')


  const stripe = useStripe();
  const elements = useElements();




  const getcountry = () => {
    fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
      .then(res => res.text())
      .then(count => {
        console.log(count)

        const countryData = countries.filter(country =>
          country.code === count // Ensure exact match
        );


        setCountryCode(countryData[0].dial_code)

      })
  }




  async function createTransaction(body) {
    try {
      const response = await fetch('https://0l3a26rip1.execute-api.eu-central-1.amazonaws.com/live/giftbox_transaction?action=createTransaction', {
        method: 'POST',
        body: JSON.stringify(body)
      }).then(res => res.json())
      return response[0]
    } catch (e) {
      console.log(e)
    }
  }


  // async function ConfirmTransaction(id) {
  //   try {
  //     const response = await fetch('https://l7es38hi1f.execute-api.eu-central-1.amazonaws.com/default/giftbox_transaction?action=confirmTransaction', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',  // Adding the Content-Type header
  //       },
  //       body: JSON.stringify({ TransactionID: id , userID:userID }),  // Sending the TransactionID as JSON
  //     });

  //     if (!response.ok) {
  //       // Handling non-200 responses
  //       throw new Error(`Request failed with status ${response.status}`);
  //     }

  //     const responseData = await response.json();
  //     return responseData;
  //   } catch (e) {
  //     console.log('Error during confirmation:', e);
  //     return null;  // Returning null or you can customize the error return based on your needs
  //   }
  // }



  const handleSubmit = async (event) => {

    if (!mobile.startsWith(countryCode)) {
      setshowAlert(true);
      setMessage('Please enter a mobile number with country code');
    }
    event.preventDefault();

    const transactionBody = {
      external_id: generateUniqueId(),
      product_id: product.product.id,
      auto_confirm: false,
      beneficiary: {
        email,
        first_name: firstName,
        last_name: lastName,
        mobile_number: mobile,
      },
    };

    let credit_party_identifier = {};

    if (product.product.required_credit_party_identifier_fields) {
      const fields = product.product.required_credit_party_identifier_fields;
      if (JSON.stringify(fields[0]) === '["mobile_number"]') {
        credit_party_identifier = { mobile_number: mobile };
      } else {
        credit_party_identifier = { account_number: accountNumber };
      }
      transactionBody.credit_party_identifier = credit_party_identifier;
    }

    let debit_party_identifier = null;
    if (product.product.debit_party_identifier) {
      const fields = product.product.debit_party_identifier;
      if (JSON.stringify(fields[0]) === '["mobile_number"]') {
        debit_party_identifier = { mobile_number: mobile };
      }
      transactionBody.debit_party_identifier = debit_party_identifier;
    }

    console.log(transactionBody);

    try {
      setLoader(true);
      const response = await createTransaction(transactionBody);

      console.log(response);
      if (response.error === 0) {
        setTransactionID(response.message.id);
        console.log("Transaction created successfully: ", response.message.id);

        if (!stripe || !elements) {
          console.log("Stripe.js has not loaded yet.");
          return;
        }

        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: `${getLiveURL()}/thankyou?TransactionID=${response.message.id}&price=${product.product.prices.retail.amount}&image=${product.product.image}`,
          },
        });

        if (error) {
          console.log(error);
          setshowAlert(true);
          setMessage('Stripe error');
        }
      } else {
        setshowAlert(true);
        setMessage(response.message.errors[0]?.message || "Unknown error");
      }
    } catch (err) {
      console.error("Error:", err);
      setshowAlert(true);
      setMessage('Stripe error 2');
    } finally {
      setLoader(false); // Only stop loader in finally, no error message
    }
  };


  function getLiveURL() {
    const currentURL = new URL(window.location.href); // Get the current page URL
    const liveHost = currentURL.host; // Extract the host (without protocol)

    return `https://${liveHost}`; // Return the new dynamic URL
  }



  function generateUniqueId() {
    const timestamp = Date.now(); // Current time in milliseconds
    const randomNum = Math.floor(Math.random() * 100000); // Random 5-digit number
    return `${timestamp}${randomNum}`; // Concatenating both ensures uniqueness
  }




  useEffect(() => {
    const fetchData = async () => {
      const fields = product.product.required_credit_party_identifier_fields;
      console.log(fields);
  
      if (fields && JSON.stringify(fields[0]) === '["account_number"]') {
        setShowAccountNumber(true);
      } else {
        setShowAccountNumber(false);
      }
  
      // Fetch country code
      const code = await getcountry();
      setCountryCode(code);
    };
  
    fetchData();
  }, []);
  
  
  useEffect(() => {
    if (countryCode) {
      const userdata = JSON.parse(sessionStorage.getItem('gbx_data')).user;
      setFirstName(userdata.first_name);
      setLastName(userdata.last_name);
      setEmail(userdata.email);
      setMobile(`${countryCode}${userdata.phone}`);
    }
  }, [countryCode]); // This runs whenever countryCode updates

  return (
    <form className='checkoutForm' onSubmit={handleSubmit} >


      {showAlert ? <div class="alert alert-danger  d-flex align-items-center" role="alert">
        <div>
          <h5>Error Completing Checkout</h5> <br />
          {message}
        </div>
      </div> : ""}

      <div className="row mb-4">
        <div className="col-md-6 col-lg-4 d-flex flex-column">
          <label>Name</label>
          <input
            required
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Name"
          />
        </div>

        <div className="col-md-6 col-lg-4 d-flex flex-column">
          <label>Last Name</label>
          <input
            required
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Last Name"
          />
        </div>

        <div className="col-md-6 col-lg-4 d-flex flex-column">
          <label>Mobile</label>
          <input
            required
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder={countryCode}
          />
        </div>

        {ShowAccountNumber ?
          <div className="col-md-6 col-lg-12 d-flex flex-column">
            <label>Account Number</label>
            <input
              required
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              placeholder="Enter you account number"
            />
          </div> : null}

        <div className="col-md-12 col-lg-12 d-flex flex-column">
          <label>Email</label>
          <input
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
        </div>
      </div>

      <PaymentElement />


      <button className='home_button_purple my-4' id='submit' disabled={!stripe}>
        {loader ? <span className='loader' ></span> : "Submit"} </button>

    </form>
  )
};

export default CheckoutForm;